import config from './config.js'

export default {

  viewparams: {"page":1,"rows":20,"search":"","sort":"map_id","sdir":"asc"},

  // list customer selection from server
  list: function(ctrl,cb_success) {
    var u = config.baseUrl + 'rest/catalogs/list?page=' + this.viewparams.page + '&rows=' + this.viewparams.rows + '&sidx=' + this.viewparams.sort + '&sord=' + this.viewparams.sdir;
    if (this.viewparams.search !== '') {
      u += '&search=' + encodeURIComponent(this.viewparams.search);
    }
    config.get(ctrl,u,'Katalogliste laden',cb_success);
  },

  // list customer selection from server
  delete: function(ctrl,id,cb_success) {
    var u = config.baseUrl + 'rest/catalogs/delete?id=' + encodeURIComponent(id);
    config.get(ctrl,u,'Katalog löschen',cb_success);
  },

  // save pdf document
  save: function(ctrl,name,file,cb_success) {
    var fd   = new FormData();
    console.log(name);
    if (!name || name.length == 0) {
      this.$bvToast.toast('Bitte erst einen Katalog-Namen eingeben.',{title: 'Warnung',variant:"warning"});
      return;
    }
    if (file.files.length == 0) {
      this.$bvToast.toast('Bitte zuerst eine PDF Katalog-Datei auswählen.',{title: "Warnung",variant: "warning"});
      return;
    }
    fd.append("filename",file.files[0]);
    fd.append("name",name);
    console.log(fd);
    config.post(this,config.baseUrl + 'rest/catalogs/save','Katalog speichern',fd,cb_success);
  }
}
